module.exports = __webpack_public_path__ + "img/icon.4d3a4306.png";